import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useAxisAuth2ndApiFeatureFlag = (): boolean =>
  useBooleanFlagValue('axis-auth-2nd-api-feature', false);
